import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import ReportSection from '@components/ReportSection';

export const HoldingsReportSection = styled(ReportSection)`
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
`;

export const SearchAndAddHoldingWrapper = styled.div`
  vertical-align: top;
  margin-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    margin-top: -4px;
    margin-bottom: 20px;
  `}
  ${media.lgUp`
    margin-bottom: ${({ theme }) => theme.x3spacePx}px;
  `}
`;

export const HoldingsWrapper = styled.section`
  padding-bottom: ${({ theme }) => theme.x2spacePx}px;
  ${media.mdUp`
    padding-top: ${({ theme }) => theme.x6spacePx}px;
    padding-bottom: ${({ theme }) => theme.x6spacePx}px;
    border-top: 30px solid #4b5965;
  `}
  ${media.smDown`
    > h1 {
      display: none;
    }
  `}
`;

export const MutedHeader = styled('span')`
  opacity: 0.5;
`;
